import React, { createContext, useContext, useReducer, useEffect } from 'react';
import { AppReducer, Types } from './reducer';
import { useHistory } from 'react-router-dom';
import { useSandboxLogout, useSandboxSendReport, useSandboxExistsReport } from '@/hooks/useSandbox/index';

// https://endertech.com/blog/using-reacts-context-api-for-global-state-managements

const SANDBOX_STORAGE_KEY = 'is_sandbox';

const storage = {
	organization: localStorage.getItem('organization'),
	company: localStorage.getItem('company'),
	user: localStorage.getItem('info_user')
};

const raw = localStorage.getItem(SANDBOX_STORAGE_KEY);
const isSandbox = raw && raw !== 'undefined' ? JSON.parse(raw) : false;

const defaultState = {
	organization: storage.organization ? JSON.parse(storage.organization) : null,
	company: storage.company ? JSON.parse(storage.company) : null,
	user: storage.user ? JSON.parse(storage.user)?.user : null,
	siderCollapsed: true,
	isSandbox: isSandbox,
	setOrganization: (data) => { },
	setCompany: (data) => { },
	clearProject: () => { },
	handleSiderCollapse: (collapsed) => { },
	toggleSandbox: (isSandbox) => { },
	sendReport: (params, url) => { },
	existsReport: (params) => { },
	setSandbox: (value) => { }
};

const ApplicationContext = createContext(defaultState);

export const ApplicationProvider = ({ children }) => {
	const [state, dispatch] = useReducer(AppReducer, defaultState);

	const history = useHistory();
	const { mutateAsync: logout } = useSandboxLogout();
	const { mutateAsync: send } = useSandboxSendReport();

	function setOrganization(item) {
		dispatch({ type: Types.SET_ORGANIZATION, payload: item });
	}

	function setCompany(item) {
		localStorage.setItem('organization', JSON.stringify(state.organization));
		localStorage.setItem('company', JSON.stringify(item));
		dispatch({ type: Types.SET_COMPANY, payload: item });
	}

	function setUser(item) {
		localStorage.setItem('user', JSON.stringify(item));
		dispatch({ type: Types.SET_USER, payload: item });
	}

	function clearProject() {
		localStorage.removeItem('organization');
		localStorage.removeItem('company');
		dispatch({ type: Types.CLEAR_PROJECT });
	}

	function handleSiderCollapse() {
		dispatch({ type: Types.TOGGLE_SIDER });
	}

	// Sync sandbox state with localStorage
	useEffect(() => {
		if (typeof state.isSandbox !== 'undefined') {
			localStorage.setItem(SANDBOX_STORAGE_KEY, JSON.stringify(state.isSandbox));
		}
	}, [state.isSandbox]);

	async function toggleSandbox(isSandbox) {
		if (!isSandbox) {
			await logout();
		}
		history.push('/');
		dispatch({ type: Types.SET_SANDBOX_ENABLED, payload: isSandbox });
	}

	async function sendReport(params, url) {
		await send(params);
		history.push(url);
	}

	function setSandbox() {
		dispatch({ type: Types.TOGGLE_SANDBOX });
	}

	function existsReport(params) {
		if (!state.isSandbox || !params.file_id) return false;
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data: exists } = useSandboxExistsReport(
			params,
			!!params.file_id && !!params.company_id && !!params.organization_id
		);
		return exists;
	}

	const context = {
		...state,
		setOrganization,
		setCompany,
		setUser,
		clearProject,
		handleSiderCollapse,
		toggleSandbox,
		sendReport,
		setSandbox,
		existsReport
	};

	return <ApplicationContext.Provider value={context}>{children}</ApplicationContext.Provider>;
};

export function useApplicationContext() {
	const context = useContext(ApplicationContext);
	return context;
}
